import { render, staticRenderFns } from "./SchedulingTasksList.vue?vue&type=template&id=5c0bd8cf&scoped=true&"
import script from "./SchedulingTasksList.vue?vue&type=script&lang=js&"
export * from "./SchedulingTasksList.vue?vue&type=script&lang=js&"
import style0 from "./SchedulingTasksList.vue?vue&type=style&index=0&id=5c0bd8cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0bd8cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
